import { render, staticRenderFns } from "./service-locations-disclaimers.vue?vue&type=template&id=274a42fb&scoped=true&"
import script from "./service-locations-disclaimers.vue?vue&type=script&lang=js&"
export * from "./service-locations-disclaimers.vue?vue&type=script&lang=js&"
import style0 from "./service-locations-disclaimers.vue?vue&type=style&index=0&id=274a42fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274a42fb",
  null
  
)

export default component.exports